"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pluto = void 0;
var Colony_1 = require("./Colony");
var ColonyName_1 = require("./ColonyName");
var ColonyBenefit_1 = require("./ColonyBenefit");
var Pluto = (function (_super) {
    __extends(Pluto, _super);
    function Pluto() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = ColonyName_1.ColonyName.PLUTO;
        _this.description = 'Cards';
        _this.buildType = ColonyBenefit_1.ColonyBenefit.DRAW_CARDS;
        _this.buildQuantity = [2, 2, 2];
        _this.tradeType = ColonyBenefit_1.ColonyBenefit.DRAW_CARDS;
        _this.tradeQuantity = [0, 1, 2, 2, 3, 3, 4];
        _this.colonyBonusType = ColonyBenefit_1.ColonyBenefit.DRAW_CARDS_AND_DISCARD_ONE;
        return _this;
    }
    return Pluto;
}(Colony_1.Colony));
exports.Pluto = Pluto;
//# sourceMappingURL=Pluto.js.map